import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Paper from 'components/UI/Paper'
// icons
import CloseIconOrigin from '@mui/icons-material/Close'
// utils
import { size } from 'polished'

const CloseIcon = styled(({ iconSize, marginLeft, ...props }: any) => <CloseIconOrigin {...props} />)`
  && {
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : 'auto')};
    ${({ iconSize }) => size(`${iconSize ? iconSize : 20}px`)};
  }
`

const ViewConditionWrapper = styled('div')`
  display: flex;
  align-items: center;
  font-weight: 500;
  margin: 8px 0 16px;

  & > div:first-child {
    flex: 1;
    font-weight: normal;
    margin: 0 16px;
  }
`

const Wrapper = styled(Paper)`
  && {
    display: flex;
    flex-direction: column;
    margin: 16px 0;
    padding: 16px;
  }
`

export { CloseIcon, ViewConditionWrapper, Wrapper }
